export { neq as default } from "@ember/helper";
